module.exports = __webpack_public_path__ + "d4c889c906de4250acfbf691a80ad78b.svg";